/* @flow */
import Reflux from "reflux";

import MobileNavigationActions from "../actions/MobileNavigationActions";
import MENU_STATE from "../components/general/mobileheader/MenuState";
type MenuStateType = "categories" | "sitecore" | "start" | "mystore" | "myaddresses";

type MobileMenuState = {
    menuState: MenuStateType | undefined | null;
    isMenuVisible: boolean;
    currentPath: Array<string>;
    transitionName: string;
};

let componentState: MobileMenuState;

export default Reflux.createStore({
    init() {
        this.listenTo(MobileNavigationActions.CloseMobileMenu, this.closeMenu);
        this.listenTo(MobileNavigationActions.ChangeState, this.setMenuState);
        this.listenTo(MobileNavigationActions.OpenSubcategory, this.openSubcategory);
        this.listenTo(MobileNavigationActions.OpenSubTree, this.openSubTree);
        componentState = {
            menuState: MENU_STATE.START,
            isMenuVisible: false,
            currentPath: [],
            transitionName: "animation-slide-left"
        };
    },

    getInitialState() {
        return componentState;
    },

    setMenuState(state: MenuStateType, transitionLeft: boolean) {
        componentState.menuState = state;
        componentState.isMenuVisible = true;
        componentState.currentPath = [];
        componentState.transitionName = transitionLeft ? "animation-slide-left" : "animation-slide-right";
        window.document.body.classList.add("disable-scrolling");
        this.trigger();
    },

    closeMenu() {
        componentState.isMenuVisible = false;
        window.document.body.classList.remove("disable-scrolling");
        this.trigger();
    },

    openSubcategory(transitionLeft: boolean) {
        componentState.isMenuVisible = true;
        if (componentState.menuState !== MENU_STATE.ASSORTMENT) {
            componentState.currentPath = [];
            componentState.menuState = MENU_STATE.ASSORTMENT;
        }
        componentState.transitionName = transitionLeft ? "animation-slide-left" : "animation-slide-right";
        window.document.body.classList.add("disable-scrolling");
        this.trigger();
    },

    openSubTree(currentPath: Array<string>, transitionLeft: boolean) {
        componentState.currentPath = currentPath;
        componentState.isMenuVisible = true;
        componentState.transitionName = transitionLeft ? "animation-slide-left" : "animation-slide-right";
        window.document.body.classList.add("disable-scrolling");
        this.trigger();
    }
});
